import React, { FC, useEffect, useState } from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { Edit } from '../constructor/work/Edit';
import { InputSizeSide } from './InputSizeSide';
import {
  EventChangeSector,
  EventChangeSectorType,
  EventUpdateControlPoint,
  SideBetweenControlPointType,
} from '../helpers/events';
import { COLORS_CONST } from '../helpers/styles';
import { useHandlerNotificationApp } from '../hooks/useHandlerNotificationApp';
import { useCreateProjectMutation } from '../graphql/mutations/__generated__/createProject';
import { useLocation } from 'react-router-dom';
import {
  CalculationResultType,
  ItemsCalculationResultType,
  SupportsGroupType,
  UrlParamsObjectType,
} from '../constructor/types';
import { useUpdateProjectMutation } from '../graphql/mutations/__generated__/updateProject';
import { GetProjectsDocument } from '../graphql/query/__generated__/getProjects';
import { useGetMe } from '../graphql/query/hooks/useGetMe';
import { useGetNameProjectQuery } from '../graphql/casheQuery/__generated__/getNameProject';
import { ProjectStatusEnum } from '../__generated__/types';

interface Props {
  sector: string;
}

export const AddingSectorComponent: FC<Props> = ({ sector }) => {
  const { me } = useGetMe();
  const location = useLocation().state as UrlParamsObjectType;
  const { addNotification } = useHandlerNotificationApp();
  const [runCreateProject] = useCreateProjectMutation();
  const [runUpdateProject] = useUpdateProjectMutation();
  const { data: dataProject } = useGetNameProjectQuery();
  const [dataSidesSections, setDataSidesSections] = useState<SideBetweenControlPointType[]>(
    Edit.linesSection
  );
  const [areaSection, setAreaSection] = useState(() => {
    return Edit.sectionsObjects?.getAreaSector() || 0;
  });
  const [isSector, setIsSector] = useState(!!Edit.sectionsObjects);
  const [currentScreenshot, setCurrentScreenshot] = useState<string>();

  const handlerButtonSave = async () => {
    const imgBase64 = await Edit?.Load?.getScreenshot();
    let background_base64;
    let background_info;
    const calculation_result = getCalculationResult();

    if (Edit?.drawingSubstrate) {
      background_base64 = Edit.drawingSubstrate.base64data;
      if (Edit?.drawingSubstrate && Edit.drawingSubstrate?.paramsPruning) {
        background_info = JSON.stringify(Edit.drawingSubstrate.paramsPruning);
      }
    }
    const str = Edit.saveSector();
    if (str) {
      try {
        let response;
        if (!location?.code) {
          response = await runCreateProject({
            variables: {
              name: dataProject?.nameProject || '',
              sector: str,
              schema_base64: imgBase64 ? imgBase64 : undefined,
              status: ProjectStatusEnum.Saved,
              background_base64,
            },
            refetchQueries: [
              {
                query: GetProjectsDocument,
                variables: {
                  user_id: me?.id,
                },
              },
            ],
          });
        } else {
          response = await runUpdateProject({
            variables: {
              code: location.code,
              sector: str,
              status: calculation_result ? ProjectStatusEnum.Done : ProjectStatusEnum.Saved,
              schema_base64: imgBase64 ? imgBase64 : undefined,
              background_base64,
              background_info,
              calculation_result: JSON.stringify(calculation_result),
            },
            refetchQueries: [
              {
                query: GetProjectsDocument,
                variables: {
                  user_id: me?.id,
                },
              },
            ],
          });
        }

        if (response) {
          // console.log(Edit.Load?.scene.children)
          addNotification({
            messageError: 'Сектор успешно сохранен',
            typeMessage: 'success',
          });
          if (!location?.code) {
            addNotification({
              messageError: 'Вы успешно создали новый проект',
              typeMessage: 'info',
            });
          }
        }
      } catch (error) {
        console.error('[ERROR_GRAPHQL]:', error);
      }
      // localStorage.setItem('sector', str);
    }
  };
  const addingSector = () => {
    Edit.addingSector();
  };
  const removeSector = () => {
    Edit.removeSector();
  };
  const handlerUpdateSidesSection = () => {
    setDataSidesSections(Edit.linesSection);
    const area = Edit.sectionsObjects?.getAreaSector() || 0;
    setAreaSection(area);
  };
  const handlerButtonRestore = () => {
    Edit.restoreSector(sector);
  };
  const handlerChangeSector = (evt: CustomEvent<EventChangeSectorType>) => {
    setIsSector(evt.detail.isSector);
  };
  const handlerButtonAddScreenshot = async () => {
    const data = await Edit?.Load?.getScreenshot();
    setCurrentScreenshot(data);
    // Load.clearScreenshotData();
  };

  function getCalculationResult(): CalculationResultType | undefined {
    let _selSupp: SupportsGroupType['selectSupports'];
    let _compensatingLining: SupportsGroupType['compensatingLining'];
    if (Edit.supportsGroupTimber) {
      _selSupp = Edit.supportsGroupTimber.selectSupports;
      _compensatingLining = Edit.supportsGroupTimber.compensatingLining;
    } else if (Edit.supportsGroup) {
      _selSupp = Edit.supportsGroup.selectSupports;
      _compensatingLining = Edit.supportsGroup.compensatingLining;
    } else {
      return;
    }

    if (_selSupp) {
      const keysSupport = Object.keys(_selSupp);
      keysSupport.sort();
      const typeProduct =
        Edit.selectModificationSupport === 'basicProfessional'
          ? 'Basic Professional'
          : 'Basic Standard';
      const dataItems: Array<ItemsCalculationResultType> = keysSupport.map(item => {
        return {
          item_circle: _selSupp ? _selSupp[item].color : '',
          item_count: _selSupp ? _selSupp[item].quantity : 0,
          item_index: item.toUpperCase(),
          item_name: `опора ${typeProduct} ${item.toUpperCase()}`,
          item_unit: 'шт.',
        };
      });
      if (_compensatingLining) {
        dataItems.push({
          item_circle: 'transparent',
          item_count: _compensatingLining,
          item_index: 'НО_7-14',
          item_name: `Подкладка под опору`,
          item_unit: 'шт.',
        });
      }
      return {
        values: {
          production_type: typeProduct,
          project_name: dataProject?.nameProject ?? '',
        },
        tables: {
          items: dataItems,
        },
      };
    }
  }

  useEffect(() => {
    document.addEventListener(EventUpdateControlPoint, handlerUpdateSidesSection);
    document.addEventListener(EventChangeSector, handlerChangeSector);
    return () => {
      document.removeEventListener(EventUpdateControlPoint, handlerUpdateSidesSection);
      document.removeEventListener(EventChangeSector, handlerChangeSector);
    };
  }, []);

  return (
    <Stack display="flex">
      <Typography fontSize={24} color="#fff">
        ШАГ 2
      </Typography>
      <Typography mb={3} color="#fff">
        Задайте длину сторон
      </Typography>
      <Button
        fullWidth
        variant="contained"
        onClick={isSector ? removeSector : addingSector}
        sx={{ marginBottom: '10px' }}
      >
        {isSector ? 'Удалить сектор' : 'Добавить сектор'}
      </Button>
      <Button
        disabled={isSector}
        fullWidth
        variant="contained"
        onClick={handlerButtonRestore}
        sx={{
          marginBottom: '10px',
          '&:disabled': {
            color: 'rgba(255,255,255,0.53)',
            backgroundColor: 'rgba(0,0,0,0.45)',
          },
        }}
      >
        Восстановить сектор
      </Button>
      <Button
        fullWidth
        variant="contained"
        onClick={handlerButtonSave}
        sx={{ marginBottom: '10px' }}
      >
        Сохранить сектор
      </Button>
      <Button
        fullWidth
        variant="contained"
        onClick={handlerButtonAddScreenshot}
        sx={{ marginBottom: '10px' }}
      >
        Посмотреть картинку
      </Button>
      <Box maxHeight="400px" overflow="auto">
        {dataSidesSections.map((item, index) => {
          return (
            <InputSizeSide
              angleA={item.angleStart}
              angleB={item.angleEnd}
              nameA={item.nameStart}
              nameB={item.nameEnd}
              key={`${item.nameStart}${index.toString()}`}
              text={(item.length * 1000).toFixed()}
              label={`Сторона ${item.nameStart} - ${item.nameEnd}`}
            />
          );
        })}
      </Box>
      <Box width="100%" height="160px" bgcolor="#000" mt={2}>
        <img src={currentScreenshot} style={{ width: '100&', height: '100%' }} alt="The image" />
      </Box>

      <Typography mt={2} textAlign="center" color="#fff">
        Ваша площадь:
      </Typography>
      <Typography textAlign="center" color={COLORS_CONST.red}>{`${(areaSection / 1000).toFixed(
        4
      )} м.кв`}</Typography>
    </Stack>
  );
};
